import {
 computed, unref, watchEffect
} from '@vue/composition-api';
import { useState, useGetters, useMutations } from 'vuex-composition-helpers';
import { DepartureCity } from '@ve/types';

export default (storeModuleName: string, context: any) => {
    const {
        getAvilableCitiesWithoutEmptyDepartures: departureCities,
        getNameCurrentDepartureCity: currentDepartureCity,
    } = useGetters(storeModuleName,
        ['getAvilableCitiesWithoutEmptyDepartures',
        'getNameCurrentDepartureCity']);
    const {
        setDepartureCity,
        setVisibleBanner,
        setStartSearch,
        addEmptyCities,
        setPrevDeparture,
    } = useMutations(storeModuleName,
        ['setDepartureCity',
        'setVisibleBanner',
        'setStartSearch',
        'addEmptyCities',
        'setPrevDeparture']);
    const {
        loadingState,
        tourProducts,
        idDefaultDepartureCity,
        idCurrentDepartureCity,
        visibleBanner,
        searchWasStart,
        prevDepartureCity,
        isAlternativeSearchStop,
        visibleBannerByMap,
    } = useState(storeModuleName,
        ['loadingState',
        'tourProducts',
        'idDefaultDepartureCity',
        'idCurrentDepartureCity',
        'visibleBanner',
        'searchWasStart',
        'prevDepartureCity',
        'isAlternativeSearchStop',
        'visibleBannerByMap',
    ]);

    const isStartAlternativeSearch = computed(() => { // Переменная отвечает за старт альтернативного поиска
        if ((loadingState.value === 'finished' || searchWasStart.value) && !tourProducts.value) {
            return true;
        }
        return false;
    });

    const isAlternativeSearchHasTour = computed(() => { // Когда альтернативный поиск начался и там есть выдача
        if (searchWasStart.value && tourProducts.value > 0) {
            return true;
        }
        return false;
    });

    watchEffect(() => {
        if (isStartAlternativeSearch.value && !searchWasStart.value) {
            setStartSearch(true);
            const nameDeparture = currentDepartureCity.value;
            const idDeparture = idCurrentDepartureCity.value;
            setDepartureCity(unref(idDefaultDepartureCity));
            setPrevDeparture({ id: idDeparture, name: nameDeparture });
            addEmptyCities(unref(prevDepartureCity));
            context.emit('startAlternativeSearchAuto', unref(idDefaultDepartureCity));
        }
    });

    watchEffect(() => {
        if (isAlternativeSearchHasTour.value && !isAlternativeSearchStop.value) {
            setVisibleBanner(true);
        }
    });

    const changeCity = (city: DepartureCity) => {
        setDepartureCity(city.id);
        setStartSearch(false);
        context.emit('startAlternativeSearchManual', city.id);
    };

    return {
        departureCities,
        currentDepartureCity,
        changeCity,
        visibleBanner,
        isStartAlternativeSearch,
        prevDepartureCity,
        visibleBannerByMap,
    };
};
